// extracted by mini-css-extract-plugin
export default {"container":"PrivacySection_container__Zucvq","title":"PrivacySection_title__htsEM"};